import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Tab, Tabs } from 'react-bootstrap';
import { actions } from '../redux/mtaRequestActions';
import { Button, Loader } from '../../../common/components';
import InternalContainer from '../../layout/containers/Internal';
import { FullRow, InternalButtonBar } from '../../layout/components';
import { bindActionCreators } from 'redux';
import MtaRequestDetails from '../components/MtaRequestDetails/MtaRequestDetails';
import Box from '../../../common/components/Box/Box';
import MtaRequestNotes from '../components/MtaRequestNotes/MtaRequestNotes';
// import ComplaintDetails from '../components/ComplaintDetails';
// import ComplaintNotes from '../components/ComplaintNotes';

const MtaRequestShowContainer = ({ params, actions, mtaRequest }) => {
  const [activeTab, setActiveTab] = useState(1);

  useEffect(() => {
    actions.getMtaRequest(params.id);
  }, []);

  const handleTab = (key) => {
    setActiveTab(key);
  };

  const markAsResponded = (resourceId) => () => {
    Promise.resolve(actions.respondToMtaRequest(resourceId)).then(() => {
      actions.getMtaRequest(params.id);
    });
  };
  const resource = mtaRequest.resources[params.id];

  if (!resource) {
    return (
      <InternalContainer
        title="Mta Request"
        buttons={
          <Button
            bsStyle="default"
            label="back"
            isBackButton={true}
            leftIcon="caret-left"
          />
        }
      >
        <Loader />
      </InternalContainer>
    );
  }

  return (
    <InternalContainer
      title="Mta Request"
      buttons={
        <Button
          bsStyle="default"
          label="back"
          isBackButton={true}
          leftIcon="caret-left"
        />
      }
    >
      <Tabs
        activeKey={activeTab}
        id="mta-request-tabs"
        unmountOnExit={true}
        onSelect={handleTab}
      >
        <Tab eventKey={1} title="Details">
          <Box>
            <MtaRequestDetails mtaRequest={resource} />
            {resource.data.attributes.status === 'received' && (
              <FullRow>
                <InternalButtonBar
                  buttons={[
                    {
                      button: (
                        <Button
                          label="Mark as responded"
                          className="pull-right"
                          bsStyle="primary"
                          rightIcon="check"
                          isLoading={resource.isSubmitting}
                          handleClick={markAsResponded(resource.data.id)}
                        />
                      ),
                    },
                  ]}
                />
              </FullRow>
            )}
          </Box>
        </Tab>
        <Tab eventKey={2} title="Notes">
          <Box>
            <MtaRequestNotes resource={resource} />
          </Box>
        </Tab>
      </Tabs>
    </InternalContainer>
  );
};

export default connect(
  (state) => ({
    mtaRequest: state.mtaRequest,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(MtaRequestShowContainer);
